<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="mb-6">
					<label class="form-label" for="filters.vehicles">Miasto Wyjazdu</label>
					<ng-select
						id="originCityId"
						name="originCityId"
						[(ngModel)]="filters.originCityId"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of originCityId" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-6">
					<label class="form-label" for="filters.offerName">Oferta</label>
					<ng-select
						id="offerName"
						name="offerName"
						[(ngModel)]="filters.offerName"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of offerName" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label class="form-label" for="filters.reservation">Rezerwacja</label>
					<input
						type="text"
						class="form-control"
						id="filters.reservation"
						name="filters.reservation"
						[(ngModel)]="filters.reservation"
					/>
				</div>
				<div class="mb-3">
					<label class="form-label" for="filters.surname">Nazwisko</label>
					<input
						type="text"
						class="form-control"
						id="filters.surname"
						name="filters.surname"
						[(ngModel)]="filters.surname"
					/>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="col-sm-4">
						<button type="button" class="btn btn-secondary" (click)="filtersClear()">Wyczyść filtry</button>
					</div>
					<div class="col-sm-8 text-end">
						<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
						<button
							type="button"
							class="btn btn-secondary"
							(click)="filtersClose()"
							data-bs-dismiss="modal"
						>
							Anuluj
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
